module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "في-المساء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في المساء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قَضَى الشَّباب نصف النَّهار في النَّوم ولَم يشأ \"مالك\" إيقاظِهم بعد الَّذي سمعه منهم من أمورٍ عاشوها قبل وُصولهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالِك: وأخيرًا استيقظتِ يا حياة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت حياة: نعم وأخيرًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثم سحبَت الكرسيَّ في غرفة الطّعام وجلستْ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- جيدٌ، سأُحضر الشّاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سآتي معك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهضَت حياة وتبعت مالك إلى المطبخ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتعلمُ يا عمّ مالك! لو كان لي الخيار في اختيار طريقة حياتي لاخترتُ أن أعيشها مثلك.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظَرَ إليها مالِك وبيده علبة الشَّاي: حقًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثمَّ وضع بعض أوراق الشَّاي في الغلَّاية على النّار وأكمل إِعْداد الشّاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: حقًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وماذا تعرفين عن حياة عمّك مالك؟")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعرف أنَّك تعيش حياتك بِحُرّية، تقضيها بين مزرعتك ومَسْرحكَ، وهي الحياة الَّتي أتمنّاها، وبسببها رجعتُ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هربتِ!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا يهمّ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أعرف لماذا لا تُريدين الدّراسة في الخارج مع إنها حُلم الكثيرين؟!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لكنَّه ليس حُلمي، أنا أريد أن أدرسَ في بلدي، لقد خطَّطت لتحقيق أحلامي مُسبقًا يا عمّي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل ما زلتِ على رأيكِ في العمل بالمَسْرح؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أكيد، حُلم حياتي أن أعمل معكَ، والأمر بالطَّبع لن يُعجب السيّدة فخريّة، أعرف ذلك جيدًا لكنَّني سأفعل المُستحيلَ في سبيل تحقيق ذلك وإِنْ تطلَّب الأمر أن أحارب الدُّنيا، كما فعلتَ أنتَ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ مالك: صحيحٌ أنَّني حاربتُ الدُّنيا من أجل أحلامي، لكنَّني بالمقابل خَسرتُ أهمّ شيءٍ.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتقصدُ عائلتك؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فكَّرتُ بنفسي، كنتُ أنانيًّا وركّزتُ جهدي لتحقيق أحلامي على حساب عائلتي، والآن أنا نادمٌ يا حياة.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتتْ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: سُكّر!")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ملعقتان. "), _c('strong', [_vm._v("كان ذلك صوت عليّ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلَ إلى المطبخ وأخذ مكانه على المقعد الَّذي بجانب حياة ثمَّ قال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مساءُ الخير.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وضع مالكٌ الأكواب المملوءة بالشّاي أمامهم وقال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ها يا حياة! أمستعدَّةٌ للمُواجهة؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: تريد أن تتخلّص منّي بهذه السّرعة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: أتخلَّص منكِ أنتِ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: إذًا دعني أبقى هنا اليوم، وغدًا خُذْني إلى البيت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ مالك: لا يجوزُ، ترينَ حالةَ البيت!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: لا أرى شيئًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَت إلى عليّ: قُل شيئًا يا عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: نعم، قُل شيئًا يا عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: معهُ حقّ، لا يجوز أن تَبقي هنا أكثر، عمّك مالك لم يعد يسكنُ وحدَه في هذا البيت بعد الآن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46df6840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch016.vue
// module id = 108
// module chunks = 0